import { call, select, put, takeLatest, all } from "redux-saga/effects";
import api from "../../Environment";
import {
  FETCH_EVENTS_START,
  FETCH_SINGLE_EVENT_START,
  CREATE_CHECKOUT_SESSION_START,
  SET_BOOKING_PAYMENT_SUCCESS_START,
  SET_BOOKING_PAYMENT_FAILED_START,
  FETCH_MY_EVENT_BOOKINGS_START
} from "../actions/ActionConstant";
import { createNotification } from "react-redux-notify";
import {
  getSuccessNotificationMessage,
  getErrorNotificationMessage,
} from "../../components/helper/NotificationMessage";
import {
  fetchEventsSuccess,
  fetchEventsFailure,
  fetchSingleEventSuccess,
  fetchSingleEventFailure,
  createPaymentIntentSuccess,
  createPaymentIntentFailure,
  setBookingPaymentSuccSuccess,
  setBookingPaymentSuccFailure,
  setBookingPaymentFailedStart,
  setBookingPaymentFailedFailure,
  fetchMyEventBookingsSuccess,
  fetchMyEventBookingsFailure
} from "../actions/EventAction";

function* fetchEvents() {
  try {
    const response = yield api.getMethod("event_list");
    if (response.data.success) {
      yield put(fetchEventsSuccess(response.data.data));
    } else {
      yield put(fetchEventsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchEventsFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchSingleEvent() {
  try {
    const inputData = yield select((state) => state.event.singleEvent.inputData);
    const response = yield api.postMethod("event_detail", inputData);
    if (response.data.success) {
      yield put(fetchSingleEventSuccess(response.data.data));
    } else {
      yield put(fetchSingleEventFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchSingleEventFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* createPaymentIntent() {
  try {
    const inputData = yield select((state) => state.event.session.inputData);
    const response = yield api.postMethod("create_checkout_session", inputData);
    if (response.data.success) {
      yield put(createPaymentIntentSuccess(response.data.data));
    } else {
      yield put(createPaymentIntentFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(createPaymentIntentFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* bookingPaymentSuccess() {
  try {
    const inputData = yield select((state) => state.event.bookingSuccess.inputData);
    const response = yield api.postMethod("booking_payment_success", inputData);
    if (response.data.success) {
      yield put(setBookingPaymentSuccSuccess(response.data.data));
    } else {
      yield put(setBookingPaymentSuccFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(setBookingPaymentSuccFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* bookingPaymentFailed() {
  try {
    const inputData = yield select((state) => state.event.bookingFailed.inputData);
    const response = yield api.postMethod("booking_payment_failed", inputData);
    if (response.data.success) {
      yield put(setBookingPaymentFailedStart(response.data.data));
    } else {
      yield put(setBookingPaymentFailedFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(setBookingPaymentFailedFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchMyEventBookings() {
  try {
    const inputData = yield select((state) => state.event.myEventBookings.inputData);
    const response = yield api.postMethod("my_event_booking_list", inputData);
    if (response.data.success) {
      yield put(fetchMyEventBookingsSuccess(response.data.data));
    } else {
      yield put(fetchMyEventBookingsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchMyEventBookingsFailure(error));
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}


export default function* eventSaga() {
  yield all([yield takeLatest(FETCH_EVENTS_START, fetchEvents)]);
  yield all([yield takeLatest(FETCH_SINGLE_EVENT_START, fetchSingleEvent)]);
  yield all([yield takeLatest(CREATE_CHECKOUT_SESSION_START, createPaymentIntent)]);
  yield all([yield takeLatest(SET_BOOKING_PAYMENT_SUCCESS_START, bookingPaymentSuccess)]);
  yield all([yield takeLatest(SET_BOOKING_PAYMENT_FAILED_START, bookingPaymentFailed)]);
  yield all([yield takeLatest(FETCH_MY_EVENT_BOOKINGS_START, fetchMyEventBookings)]);
}
